import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/css/modal.css';
// import './assets/css/swiper.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux/store';
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from './contexts/AuthContext';
import { SocketProvider } from './contexts/SocketContext';
import { CommonContextProvider } from './contexts/CommonContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <AuthProvider>
          <SocketProvider>
            <CommonContextProvider>
              <App />
              {/* <div className='max-xl:min-w-[1350px] max-xl:max-w-[1350px] 2xl:min-w-[1350px] 2xl:max-w-[1350px] m-auto'><App /></div> */}
            </CommonContextProvider>
          </SocketProvider>
        </AuthProvider>
      </Router>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();